import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum UpsellOrderStatus {
  pending = 'pending',
  failed = 'failed',
  paid = 'paid',
  requested = 'requested',
  rejected = 'rejected',
  fulfilled = 'fulfilled',
  refunded = 'refunded',
}

export default class UpsellOrderModel extends Model {
  @attr('date') createdAt!: Date;
  @attr('string') status!: UpsellOrderStatus;

  @belongsTo('upsell', { inverse: null, async: false })
  upsell!: ModelRegistry['upsell'];

  @belongsTo('booking', { inverse: null, async: false })
  booking!: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'upsell-order': UpsellOrderModel;
  }
}
